var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-shell m-1 sm:m-5 shadow-sm h-auto bg-white rounded-md"},[_vm._m(0),_c('div',[_c('transactions-table')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between items-center border-b-0.5 p-2"},[_c('p',{staticClass:"font-medium"},[_vm._v(" Transactions ")])])
}]

export { render, staticRenderFns }